/** Web stub — Minerva is only available on Fire OS devices. */
const minervaService = {
  recordAppEvent(_event: string) {},
};

export default minervaService;
